<template>
  <div class="longteruserread">
    <BaseTitle titleText="檢視長照用戶" />
    <LongTermUserForm
      :districtOptions="districtOptions"
      :classOptions="classOptions"
      :areaTypeOptions="areaTypeOptions"
      :serviceOptions="serviceOptions"
      :longTermUser="user"
      :disabled="isChecking"
      @userDataHandler="userDataHandler"
      @onSubmit="onSubmit"
      @onReset="onReset"
      @deleteOne="deleteOne"
    >
      <section class="longteruserread__banner" slot="banner">
        <div class="longteruserread__graphy">
          <div class="longteruserread__avator" v-if="isChecking">
            <img v-if="user.photoUrl" :src="user.photoUrl" alt="長照用戶頭像" />
            <img v-else src="@/assets/images/user.png" alt="長照用戶頭像" />
          </div>
          <div class="longteruserread__qrcode">
            <qrcode-vue :value="user.qrcodeUrl" size="150"></qrcode-vue>
          </div>
          <b-button
            class="longteruserread__qrcode-refresh"
            variant="outline-secondary"
            v-if="!isChecking"
            @click.prevent="refreshQRCode"
            >更新 QRCode</b-button
          >
        </div>
        <BaseButtonGroup
          positiveText="編輯"
          negativeText="回上一頁"
          positiveType="button"
          negativeType="button"
          @positive="isChecking = false"
          @negative="goBack"
        />
      </section>
    </LongTermUserForm>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import BaseButtonGroup from '@/components/base/BaseButtonGroup';
import LongTermUserForm from '@/components/longTerm/LongTermUserForm';
import QrcodeVue from 'qrcode.vue';

import { mapGetters, mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'longTermUser',
  components: {
    BaseTitle,
    BaseButtonGroup,
    LongTermUserForm,
    QrcodeVue
  },
  data() {
    return {
      isChecking: true
    };
  },
  methods: {
    ...mapActions({
      fetchUser: 'longTerm/fetchUser',
      updateUser: 'longTerm/updateUser',
      updateUserQRCode: 'longTerm/updateUserQRCode',
      deleteUser: 'longTerm/deleteUser'
    }),
    userDataHandler({ value, property }) {
      const data = this.user;
      data[property] = value;
      this.$store.commit('longTerm/userData', data);
    },
    async onSubmit(userData) {
      try {
        await this.updateUser({ userData, userId: this.$route.params.id });
        this.resetForm();
        this.$bvToast.toast('長照用戶更新成功', {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        });
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    onReset() {
      this.isChecking = true;
    },
    async refreshQRCode() {
      try {
        const res = await this.updateUserQRCode(this.$route.params.id);
        if (res.success) this.fetchUser(this.$route.params.id);
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    async deleteOne() {
      try {
        const res = await this.deleteUser(this.$route.params.id);
        if (res.success) this.$router.go(-1);
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    resetForm() {
      this.$store.commit('longTerm/user', {
        address: '',
        gps: [],
        area: '',
        areaType: null,
        authority: false,
        class: null,
        communityShuttleFrequency: null,
        contactPerson: '',
        firstMobilePhoneNumber: '',
        identityCode: '',
        name: '',
        note: '',
        photo: null,
        secondMobilePhoneNumber: '',
        service: [],
        telephoneNumber: '',
        verification: false
      });
      this.$store.commit('longTerm/user', {});
    }
  },
  computed: {
    ...mapGetters({
      areaTypeOptions: 'longTerm/areaTypeOptions',
      classOptions: 'longTerm/classOptions',
      districtOptions: 'longTerm/districtOptions',
      serviceOptions: 'longTerm/serviceOptions',
      longTermUsers: 'longTerm/users',
      user: 'longTerm/user'
    })
  },
  beforeRouteLeave(_to, _from, next) {
    this.resetForm();
    next();
  }
};
</script>

<style lang="scss" scoped>
.longteruserread {
  width: 65%;
  max-width: 950px;
  margin: 0 auto;

  &__banner {
    margin-bottom: 30px;
  }
  &__graphy {
    display: flex;
    align-items: center;
    padding: 30px 0;
  }
  &__avator {
    max-width: 300px;
    border-radius: 9999px;
    overflow: hidden;
    margin-right: 60px;
  }
  &__qrcode {
    width: 120px;
    margin-right: 50px;
    &-refresh {
      border: 1px solid $border-gentle;
      &:hover {
        border-color: #6c757d;
      }
    }
  }
  img {
    width: 100%;
  }
}
</style>
